import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Target, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 border-b">
      <div className="w-full px-4 sm:px-6">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center">
              <Target className="w-7 h-7 text-white" />
            </div>
            <span className="text-xl sm:text-2xl font-bold text-gray-900">
              Morning Sunday Teer
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-coral-600 font-medium transition-colors">
              Home
            </Link>
            <Link to="/previous-results" className="text-gray-700 hover:text-coral-600 font-medium transition-colors">
              Previous Results
            </Link>
            <Link to="/common-numbers" className="text-gray-700 hover:text-coral-600 font-medium transition-colors">
              Common Numbers
            </Link>
            <Link to="/house-target" className="text-gray-700 hover:text-coral-600 font-medium transition-colors">
              House Target
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="w-7 h-7 text-gray-900" />
            ) : (
              <Menu className="w-7 h-7 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4 space-y-1 border-t pt-2">
            <Link
              to="/"
              className="block py-2.5 px-2 text-gray-700 hover:bg-gray-100 hover:text-coral-600 font-medium transition-colors rounded"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/previous-results"
              className="block py-2.5 px-2 text-gray-700 hover:bg-gray-100 hover:text-coral-600 font-medium transition-colors rounded"
              onClick={() => setIsMenuOpen(false)}
            >
              Previous Results
            </Link>
            <Link
              to="/common-numbers"
              className="block py-2.5 px-2 text-gray-700 hover:bg-gray-100 hover:text-coral-600 font-medium transition-colors rounded"
              onClick={() => setIsMenuOpen(false)}
            >
              Common Numbers
            </Link>
            <Link
              to="/house-target"
              className="block py-2.5 px-2 text-gray-700 hover:bg-gray-100 hover:text-coral-600 font-medium transition-colors rounded"
              onClick={() => setIsMenuOpen(false)}
            >
              House Target
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
